import { colors } from './themeUtils/colors';
import { typography as typographyRebrand } from './themeUtils/typography';

const breakpoints = {
  smallest: [0, 320],
  xs: [321, 544],
  s: [545, 767],
  m: [768, 1140],
  l: [1141, 1300],
  xl: [1301, 1600],
  xxl: [1601, 1920],
  largest: [1921, Infinity],
} as const;

const layoutTheme = {
  breakpoints,
  breakpoint: {
    desktop: breakpoints.xl[0],
    tablet: breakpoints.l[0],
    mobile: breakpoints.m[0],
  },
  minWidthBreakpoint: {
    tablet: breakpoints.m[0],
    desktop: breakpoints.l[0],
  },
  navBreakpoints: {
    offset: 24,
    navItemMarginOffset: 16,
    navButtonMarginOffset: 8,
    defaultWidth: 2000,
    moreWidth: 96,
  },
  radius: {
    none: '0px',
    sm: '4px',
    md: '8px',
    lg: '16px',
    xl: '100px',
  },
  unit: (multiplier: number, baseUnit = 8) => `${multiplier * baseUnit}px`,
  unitInt: (multiplier: number, baseUnit = 8) => multiplier * baseUnit,
} as const;

const effectsTheme = {
  // z-index:
  // level 0: shop/offer card hover states
  // level 1: nav bar
  // level 2: dropdown
  // level 3: modals
  elevation: [10, 20, 30, 40],
  // accordian transitions:
  transitionDuration: 600,
  transitionDurationCssValue: '.6s',

  'elevation-shadow': {
    1: 'box-shadow: 0 2px 2px 0 var(--colour-role-border-box-shadow);',
    2: 'box-shadow: 0 4px 4px 0 var(--colour-role-border-box-shadow);',
    3: 'box-shadow: 0 8px 8px 0 var(--colour-role-border-box-shadow);',
  },

  custom: {
    HEADER_HEIGHT_MOBILE: 105,
  },
} as const;

export type AppTheme = typeof layoutTheme & {
  c: typeof colors;
  typographyRebrand: typeof typographyRebrand;
} & typeof effectsTheme;

const theme: AppTheme = {
  ...layoutTheme,
  c: colors,
  typographyRebrand,
  ...effectsTheme,
};

export default theme;
